var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Menu'),_vm._v(" "),_c('b-container',{staticClass:"py-2",style:(_vm.isMobile ? 'margin-bottom: 56px' : 'margin-top: 56px')},[_vm._t("default")],2),_vm._v(" "),_c('Toasts')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }